import { gql } from '@apollo/client';

export const ALL_FORMROLES = gql`
  query AllFormRoles {
    roles: getFormRoles {
      id
      name
    }
  }
`;
